// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"700":"18d83456","919":"db4d29fb"}[chunkId] + ".chunk.js";
};